// Built-in sticker set for kudos wall
// SVG strings for ~30 stickers. No external dependency.

export const STICKERS = [
  { id: 'trophy',    emoji: '🏆', label: 'Trophy' },
  { id: 'fire',      emoji: '🔥', label: 'Fire' },
  { id: 'rocket',    emoji: '🚀', label: 'Rocket' },
  { id: 'star',      emoji: '⭐', label: 'Star' },
  { id: 'sparkles',  emoji: '✨', label: 'Sparkles' },
  { id: 'heart',     emoji: '❤️', label: 'Heart' },
  { id: 'clap',      emoji: '👏', label: 'Clap' },
  { id: 'muscle',    emoji: '💪', label: 'Strong' },
  { id: 'party',     emoji: '🎉', label: 'Party' },
  { id: 'tada',      emoji: '🎊', label: 'Tada' },
  { id: 'gem',       emoji: '💎', label: 'Gem' },
  { id: 'crown',     emoji: '👑', label: 'Crown' },
  { id: 'lightning', emoji: '⚡', label: 'Lightning' },
  { id: 'target',    emoji: '🎯', label: 'Target' },
  { id: 'brain',     emoji: '🧠', label: 'Big Brain' },
  { id: 'handshake', emoji: '🤝', label: 'Teamwork' },
  { id: 'sunglasses',emoji: '😎', label: 'Cool' },
  { id: 'love',      emoji: '🥰', label: 'Love it' },
  { id: 'wow',       emoji: '🤩', label: 'Wow' },
  { id: 'salute',    emoji: '🫡', label: 'Salute' },
  { id: 'goat',      emoji: '🐐', label: 'GOAT' },
  { id: 'hundred',   emoji: '💯', label: '100' },
  { id: 'dragon',    emoji: '🐉', label: 'Dragon' },
  { id: 'unicorn',   emoji: '🦄', label: 'Unicorn' },
  { id: 'magnify',   emoji: '🔍', label: 'Detail' },
  { id: 'bulb',      emoji: '💡', label: 'Great idea' },
  { id: 'medal',     emoji: '🥇', label: 'Gold' },
  { id: 'shield',    emoji: '🛡️', label: 'Defender' },
  { id: 'wave',      emoji: '👋', label: 'Hi-five' },
  { id: 'ninja',     emoji: '🥷', label: 'Ninja' },
];

export function StickerPicker({ onSelect, selected }) {
  return (
    <div style={{
      display: 'flex', flexWrap: 'wrap', gap: 6,
      background: 'var(--bg-card)', border: '1px solid var(--border)',
      borderRadius: 'var(--radius)', padding: 12, maxWidth: 320
    }}>
      {STICKERS.map(s => (
        <button
          key={s.id}
          title={s.label}
          onClick={() => onSelect(selected === s.emoji ? null : s.emoji)}
          style={{
            width: 36, height: 36, borderRadius: 8, border: 'none',
            background: selected === s.emoji ? 'var(--accent-dim)' : 'var(--bg-elevated)',
            fontSize: 20, cursor: 'pointer', display: 'flex', alignItems: 'center',
            justifyContent: 'center', transition: 'all 0.15s',
            outline: selected === s.emoji ? '2px solid var(--accent)' : 'none'
          }}
        >
          {s.emoji}
        </button>
      ))}
    </div>
  );
}
